export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const KEY = 'd9082eb9-a723-42bf-bbc8-b2e378b863a7';

export const MODAL_CLOSE_SEC = 2.5;
